module.exports = __webpack_public_path__ + "img/index_map_place05.8f8f6f60.jpg";